import UIDs from "../../../../UIDs";

const uid = UIDs.screens.me.linkEmail;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,

    GET_VERIFY_CODE_ASYNC: `${uid}.getVerifyCodeAsync`,
    GET_VERIFY_CODE_SUCCESS: `${uid}.getVerifyCodeSuccess`,
    GET_VERIFY_CODE_FAILURE: `${uid}.getVerifyCodeFailure`,

    LINK_EMAIL_ASYNC: `${uid}.linkEmailAsync`,
    LINK_EMAIL_SUCCESS: `${uid}.linkEmailSuccess`,
    LINK_EMAIL_FAILURE: `${uid}.linkEmailFailure`,

    CLOSE_COUNT_DOWN: `${uid}.closeCountDown`,
    CHANGE_SETTINGS: `${uid}.changeSettings`,
};

export { ActionTypes };